export function setTimeout(timer, handler) {
  return window.setTimeout(handler, timer)
}

export function clearTimeout(id) {
  return window.clearTimeout(id)
}

export function setInterval(timer, handler) {
  return window.setInterval(handler, timer)
}

export function clearInterval(id) {
  return window.clearInterval(id)
}
